const pt = {
  "app.webcheckin.title": "Check-in online",
  "app.webcheckin.no_booking": "Nº da reserva",
  "app.webcheckin.customer": "Cliente",
  "app.webcheckin.channel": "Canal de reserva",
  "app.webcheckin.reservation_detail": "Detalhes da reserva",
  "app.webcheckin.experiences": "Experiências",
  "app.webcheckin.meal_plan": "Plano de refeições",
  "app.webcheckin.nights_quantity": "{nights} noites",
  "app.webcheckin.reserved rooms": "Quartos reservados",
  "app.webcheckin.intro_info":
    "Agora você pode fazer o check-in de forma rápida e descomplicada.",
  "app.webcheckin.view_guest": "Ver hóspedes registrados",
  "app.webcheckin.max_accommodation": "Até {max} hóspedes",
  "app.webcheckin.register_guest": "Registrar hóspedes",
  "app.webcheckin.hello": "Olá, ",
  "app.webcheckin.name_guest": "Nome",
  "app.webcheckin.type_guest": "Tipo",
  "app.webcheckin.melhous_btn": "VER MELHOUS",
  "staff.supply.no_signature": "Sem assinatura",
  "app.webcheckin.contact": "Contato",
  "app.webcheckin.experiences.melhous": "App Exclusivo para Clientes",
  "app.webcheckin.arrive.date": "Chegada",
  "app.webcheckin.departure.date": "Partida",
  "app.webcheckin.melhos.description":
    "Com a Melhous, agora você terá acesso exclusivo aos melhores serviços e experiências exclusivas para clientes. Tudo o que você precisa saber sobre nós você encontrará ",
  "app.webcheckin.melhos.click": "aqui.",
  "app.webcheckin.experiences.description":
    "Aproveite as melhores experiências que preparamos para você.",
  "app.webcheckin.msg_ok": "Registro concluído com sucesso.",
  "app.webcheckin.extra_fields": "Campos extras",
  "app.webcheckin.placeholder.description": "Escreva a descrição",
  "app.webcheckin.main_guest_description":
    "Este registro será para o hóspede principal da reserva.",
};

export default pt;
